import LocalEvaluator from "../../../../mode/local/LocalEvaluator"
import { EvaluatorContext } from "../../../../evaluator/Evaluator"
import EvaluateRequest from "../../../../EvaluateRequest"
import ExperimentLocalEvaluateRequest from "./ExperimentLocalEvaluateRequest"
import ExperimentEvaluateResponse from "../../ExperimentEvaluateResponse"
import ExperimentLocalEvaluationFlowFactory from "../../../../service/experiment/flow/ExperimentLocalEvaluationFlowFactory"
import { ExperimentEvaluateResult } from "../../../../service/experiment/ExperimentEvaluateResult"
import { DecisionReason } from "../../../../../model/model"
import EvaluationEventRecorder from "../../../../event/EvaluationEventRecorder"
import ExperimentEvaluator from "../../ExperimentEvaluator"

export default class ExperimentLocalEvaluator
  extends LocalEvaluator<ExperimentLocalEvaluateRequest, ExperimentEvaluateResponse>
  implements ExperimentEvaluator<ExperimentLocalEvaluateRequest>
{
  constructor(
    private readonly experimentFlowFactory: ExperimentLocalEvaluationFlowFactory,
    private readonly eventRecorder: EvaluationEventRecorder
  ) {
    super()
  }

  supports(request: EvaluateRequest): request is ExperimentLocalEvaluateRequest {
    return request instanceof ExperimentLocalEvaluateRequest
  }

  protected doEvaluate(request: ExperimentLocalEvaluateRequest, context: EvaluatorContext): ExperimentEvaluateResponse {
    const flow = this.experimentFlowFactory.flow(request.experiment.type)
    const result =
      flow.evaluate(request, context) ??
      ExperimentEvaluateResult.ofControl(DecisionReason.TRAFFIC_NOT_ALLOCATED, request)
    return ExperimentEvaluateResponse.of(request, context, result)
  }

  record(_request: ExperimentLocalEvaluateRequest, response: ExperimentEvaluateResponse): void {
    this.eventRecorder.record(response)
  }
}
